export enum AiSistantDisplayModeEnum {
  init = 0, // PP is loaded
  click = 1, // requested by advisor
}
